import React from 'react';
import { Button, Form, Modal } from 'antd';
import { changeStatusPartnerRequest } from '../../../services/partnerRequest';
import DetailLabel from '../../../components/DetailLabel';
import { checkPermission } from '../../../utils/checkPermission';
import { LIST_STATUS_PARTNER } from '../../../constants/appSelect';
import { PARTNER_STATUS_CHANGE } from '../../../constants/apiEndPoint';

const ThongTinDoiTac = ({ Confirm, selectedPartnerId, visible, refetchDataPartners }) => {
  const [form] = Form.useForm();

  const handleClose = () => {
    Confirm(false);
  };

  const handleStatusChange = async (value) => {
    if (!selectedPartnerId) return;
    try {
      const newStatus = value;
      const response = selectedPartnerId.id.toString();
      await changeStatusPartnerRequest(response, newStatus);
      Confirm(false);
      await refetchDataPartners();
    } catch (error) {
      console.error('Error changing status:', error);
    }
  };

  const statusChange = () => {
    if (!selectedPartnerId) return null; // Prevents errors if no record is selected
    if (selectedPartnerId.status === 1) {
      return (
        <>
          {checkPermission(PARTNER_STATUS_CHANGE, 'Duyệt') && (
            <Button type="primary" danger onClick={() => handleStatusChange(3)}>
              Ngừng hợp tác
            </Button>
          )}
        </>
      );
    } else {
      return (
        <>
          {checkPermission(PARTNER_STATUS_CHANGE, 'Duyệt') && (
            <Button className="ml-3" type="primary" onClick={() => handleStatusChange(1)}>
              Kích hoạt
            </Button>
          )}
        </>
      );
    }
  };

  return (
    <Modal
      title="Thông tin đối tác"
      open={visible} // Always open since it's controlled externally
      onCancel={handleClose}
      footer={null}
      width={600}
      height={334} // Remove default footer buttons
    >
      <Form form={form} labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
        <div className="grid grid-cols-2 gap-3 items-center">
          <DetailLabel header="Tên đối tác:" text={selectedPartnerId?.name || 'N/A'} />
          <DetailLabel header="Mô tả:" text={selectedPartnerId?.description || 'N/A'} />
          <DetailLabel header="Số điện thoại:" text={selectedPartnerId?.phone || 'N/A'} />
          <DetailLabel header="Email:" text={selectedPartnerId?.email || 'N/A'} />
          <DetailLabel header="Địa chỉ:" text={selectedPartnerId?.address || 'N/A'} />
          <div className="text-right flex justify-start">
            <h4 className="font-medium text-sm leading-[14px]">Trạng thái:</h4>
          </div>
          <div>
            <span
              className="font-normal text-sm leading-[14px] -ml-24"
              style={{
                backgroundColor: LIST_STATUS_PARTNER.find((item) => item.value === selectedPartnerId?.status)?.color,
                color: 'white',
                borderRadius: '8px',
                padding: '4px 10px',
              }}
            >
              {LIST_STATUS_PARTNER.find((item) => item.value === selectedPartnerId?.status)?.label}
            </span>
          </div>
        </div>

        <div className="flex justify-center mt-4">
          <Form.Item>{statusChange()}</Form.Item>
        </div>
      </Form>
    </Modal>
  );
};

export default ThongTinDoiTac;
